import { CommonModule } from '@angular/common';
import {
	Directive,
	ElementRef,
	EventEmitter,
	Input,
	NgModule,
	OnDestroy,
	Output,
	Renderer2,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TeleporterService } from '../services/teleporter.service';
import { TeleporterKey } from '../types/teleporter.type';

@Directive({
	standalone: false,
	selector: '[teleporterHub]',
})
export class TeleporterHubDirective implements OnDestroy {
	private key: TeleporterKey;

	private lastChildren?: HTMLElement;

	private keyChanged$ = new Subject<void>();

	@Input()
	public set teleporterHub(key: TeleporterKey) {
		if (this.key !== key) {
			try {
				this.teleporterService.removeHub(this.key);
			} catch (error) {}
			this.key = key;
			this.listenToItems();
		}
	}

	public get teleporterHub(): TeleporterKey {
		return this.key;
	}

	@Output('itemChanged')
	public readonly itemChanged$$ = new EventEmitter<HTMLElement | null>();

	constructor(
		private readonly elementRef: ElementRef<HTMLElement>,
		private readonly renderer: Renderer2,
		private readonly teleporterService: TeleporterService
	) {}

	ngOnDestroy(): void {
		this.teleporterService.removeHub(this.teleporterHub);
		this.keyChanged$.next();
		this.keyChanged$.complete();
	}

	private listenToItems(): void {
		this.keyChanged$.next();
		this.teleporterService
			.addHub(this.key)
			?.pipe(takeUntil(this.keyChanged$))
			.subscribe((item) => {
				this.clearContent();
				if (item) {
					this.renderer.appendChild(this.elementRef.nativeElement, item);
					this.lastChildren = item;
				}
				this.itemChanged$$.emit(item || null);
			});
	}

	private clearContent(): void {
		if (this.lastChildren) {
			this.renderer.removeChild(this.elementRef.nativeElement, this.lastChildren);
			this.lastChildren = undefined;
		}
	}
}

@NgModule({
	declarations: [TeleporterHubDirective],
	imports: [CommonModule],
	exports: [TeleporterHubDirective],
})
export class TeleporterHubModule {}
